import en from './en.json'
import fr from './fr.json'

export default {
  /*en,
  fr*/
}
